import {ProposalCheckboxFilter} from './proposal-checkbox-filter';
import {ObjectUtil} from '../util/object-util';
import {ProposalTileSortParameter} from '../enum/proposal-tile-sort-parameter';
import {FilterRole} from '../enum/filter-role';

export class ProposalFilterQuery {
  selectedRole: string = FilterRole.ALL;
  noCoverage: boolean = false;
  leadInsurerNeeded: boolean = false;
  followingInsurerNeeded: boolean = false;
  minimumAmountInsured: number;
  maximumAmountInsured: number;
  includeOwn = false;
  onlySubstitutes = false;
  includeLineOfBusiness: string[];
  page: number;
  pageSize: number = 15;

  sortBy: ProposalTileSortParameter;
  ascending: boolean;

  constructor(filter?: ProposalCheckboxFilter) {
    if (filter) {
      ObjectUtil.assign(this, filter);
      this.includeLineOfBusiness = [];
      if (filter.lineOfBusiness) {
        for (let lob in filter.lineOfBusiness) {
          if (filter.lineOfBusiness[lob]) {
            this.includeLineOfBusiness.push(lob);
          }
        }
      }
      if (this.includeLineOfBusiness.length == 0) {
        this.includeLineOfBusiness = null;
      }
      if (!filter.limitPrice) {
        this.minimumAmountInsured = undefined;
        this.maximumAmountInsured = undefined;
      } else {
        this.minimumAmountInsured = filter.minimumAmountInsured;
        this.maximumAmountInsured = filter.maximumAmountInsured;
      }
    }
  }

}
